function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import Player from '../template/player.art';
import DanmakuListItem from '../template/danmakuListItem.art';
import tplDanmakuEdit from '../template/set/editDanmaku.art';
import utils from './utils';
import options from './options';
var Template = function () {
    function Template(options) {
        _classCallCheck(this, Template);
        var currentVideo = options.currentVideo;
        this.container = options.container;
        options.video[currentVideo].current = true;
        options.isFireFox = utils.isFirefox;
        options.colors = [
            '#FE0302',
            '#FFFF00',
            '#FFAA02',
            '#00CD00',
            '#00FF00',
            '#4e6ef2',
            '#89D5FF',
            '#7b7ff7',
            '#757575',
            '#ffffff',
            '#fb7299',
            '#333333'
        ];
        this.options = options;
        this.init(options);
    }
    _createClass(Template, [
        {
            key: 'init',
            value: function init(options) {
                this.container.innerHTML = Player(options);
                var $ = this.container.querySelector.bind(this.container);
                var $all = this.container.querySelectorAll.bind(this.container);
                this.mask = $('.mfunsPlayer-mask');
                this.video = $('.mfunsPlayer-video');
                this.videoMask = $('.mfunsPlayer-video-mask');
                this.videoWrap = $('.mfunsPlayer-video-wrap');
                this.fullButton = $('.mfunsPlayer-controller-fullButton');
                this.danmakuRoot = $('.mfunsPlayer-video-danmaku-root');
                this.setMask = $('.mfunsPlayer-set');
                this.danmaku = $('.mfunsPlayer-danmaku');
                this.danmakuTip = $('.mfunsPlayer-danmaku-item-tip');
                this.danmakuCopy = $('.mfunsPlayer-danmaku-item-tip-copy');
                this.danmakuReport = $('.mfunsPlayer-danmaku-item-tip-report');
                this.danmakuButton = $('.mfunsPlayer-video-danmaku-button');
                this.danmakuSet = $('.mfunsPlayer-video-danmaku-set');
                this.danmakuEditMask = $('.mfunsPlayer-danmuku-edit-mask');
                this.danmakuCancelEdit = $('.mfunsPlayer-danmuku-edit-cancel');
                this.danmakuTypeItem = $all('.mfunsPlayer-danmaku-edit-item.type');
                this.danmakuSizeItem = $all('.mfunsPlayer-danmaku-edit-item.size');
                this.danmakuColorItem = $all('.mfunsPlayer-danmaku-edit-item.color');
                this.danmakuShieldItem = $all('.mfunsPlayer-danmaku-shield-type-item');
                this.danmakuAttributeBarWrap = $all('.mfunsPlayer-danmaku-attribute-bar-wrap');
                this.danmakuAttributeValue = $all('.mfunsPlayer-danmaku-attribute-value');
                this.danmakuOpacityBar = $('.mfunsPlayer-danmaku-opacity-bar');
                this.danmakuSizeBar = $('.mfunsPlayer-danmaku-size-bar');
                this.danmakuSpeedBar = $('.mfunsPlayer-danmaku-speed-bar');
                this.danmakuText = $('.mfunsPlayer-danmaku-text');
                this.danmakuEmit = $('.mfunsPlayer-danmaku-emit');
                this.danmakuSetMask = $('.mfunsPlayer-danmaku-set-mask');
                this.danmaku_filter_picker = $('.mfunsPlayer-danmaku-filter-picker');
                this.danmaku_opacity_slider = $('.mfunsPlayer-danmaku-opacity-slider');
                this.danmaku_opacity_value = $('.mfunsPlayer-danmaku-opacity-value');
                this.danmaku_showarea_slider = $('.mfunsPlayer-danmaku-showarea-slider');
                this.danmaku_showarea_value = $('.mfunsPlayer-danmaku-showarea-value');
                this.danmaku_size_slider = $('.mfunsPlayer-danmaku-size-slider');
                this.danmaku_size_value = $('.mfunsPlayer-danmaku-size-value');
                this.danmaku_speed_slider = $('.mfunsPlayer-danmaku-speed-slider');
                this.danmaku_speed_value = $('.mfunsPlayer-danmaku-speed-value');
                this.currentDanmakuListBtn = $('.mfunsPlayer-danmaku-list-btn.current');
                this.allDanmakuListBtn = $('.mfunsPlayer-danmaku-list-btn.all');
                this.danmakuListMask = $('.mfunsPlayer-danmaku-list-mask');
                this.danmakuList = $('.mfunsPlayer-danmaku-list');
                this.danmakuListItem = $all('.mfunsPlayer-danmaku-list-item');
                this.danmakuFPS = $('.mfunsPlayer-danmaku-fps-value');
                this.danmakuCurrent = $('.mfunsPlayer-danmaku-current-count-value');
                this.danmakuCount = $('.mfunsPlayer-danmaku-count-value');
                this.video_brightness_slider = $('.mfunsPlayer-filter-brightness-slider');
                this.video_brightness_value = $('.mfunsPlayer-filter-brightness-value');
                this.video_contrast_slider = $('.mfunsPlayer-filter-contrast-slider');
                this.video_contrast_value = $('.mfunsPlayer-filter-contrast-value');
                this.video_saturate_slider = $('.mfunsPlayer-filter-saturate-slider');
                this.video_saturate_value = $('.mfunsPlayer-filter-saturate-value');
                this.video_hue_rotate_slider = $('.mfunsPlayer-filter-hue-rotate-slider');
                this.video_hue_rotate_value = $('.mfunsPlayer-filter-hue-rotate-value');
                this.video_color_reset_btn = $('.mfunsPlayer-video-color-reset-btn');
                this.headBar = $('.mfunsPlayer-headBar');
                this.headBacker = $('.mfunsPlayer-headBar-back');
                this.gesture = $('.mfunsPlayer-gesture');
                this.gestureWrap = $('.mfunsPlayer-gesture-wrap');
                this.leftLock = $('.mfunsPlayer-lock-left');
                this.rightLock = $('.mfunsPlayer-lock-right');
                this.bar = $('.mfunsPlayer-bar');
                this.barWrap = $('.mfunsPlayer-bar-wrap');
                this.barMark = $('.mfunsPlayer-bar-mark');
                this.barTime = $('.mfunsPlayer-barTime');
                this.barPreview = $('.mfunsPlayer-bar-preview');
                this.playedBar = $('.mfunsPlayer-playedBar');
                this.bufferedBar = $('.mfunsPlayer-bufferedBar');
                this.thumb = $('.mfunsPlayer-thumb');
                this.headTime = $('.mfunsPlayer-headBar-time');
                this.headTitle = $('.mfunsPlayer-headBar-title');
                this.playerSet = $('.mfunsPlayer-headBar-set');
                this.barTime = $('.mfunsPlayer-barTime');
                this.bezel = $('.mfunsPlayer-bezel');
                this.tipItem = $all('.mfunsPlayer-controller-tip');
                this.speed = $('.mfunsPlayer-speed');
                this.speedMask = $('.mfunsPlayer-speed-mask');
                this.speedItem = $all('.mfunsPlayer-speed-item');
                this.playerSetMask = $('.mfunsPlayer-player-set-mask');
                this.episode = $('.mfunsPlayer-episode');
                this.episodeMask = $('.mfunsPlayer-episode-mask');
                this.episodeItem = $all('.mfunsPlayer-episode-item');
                this.skip = $('.mfunsPlayer-controller-skip');
                this.input = $('.mfunsPlayer-input-box');
                this.browserFullButton = $('.mfunsPlayer-controller-full');
                this.browserFullButtonIcon = $('.mfunsPlayer-controller-full-icon');
                this.player_btn = $('.mfunsPlayer-controller-player-btn');
                this.resolution = $('.mfunsPlayer-resolution');
                this.resolutionMask = $('.mfunsPlayer-resolution-mask');
                this.resolutionItem = $all('.mfunsPlayer-resolution-item');
                this.controllerMask = $('.mfunsPlayer-controller-mask');
                this.controller = $('.mfunsPlayer-controller');
                this.controllerLeft = $('.mfunsPlayer-controller-left');
                this.controllerRight = $('.mfunsPlayer-controller-right');
                this.controllerWrap = $('.mfunsPlayer-controller-wrap');
                this.loading = $('.mfunsPlayer-loading');
                this.loadingSpeed = $('.mfunsPlayer-loading-speed');
                this.troggle = $('.mfunsPlayer-troggle');
                this.noticeList = $('.mfunsPlayer-notice-list');
                this.currentTime = $('.currentTime');
                this.total = $('.total');
                this.voice = $('.voice');
                this.videoMirror = $('.mfunsPlayer-player-set.headbar-item.mirror');
                this.videoFilter = $('.mfunsPlayer-player-set.headbar-item.filter');
                this.videoFilterMask = $('.mfunsPlayer-player-videoFilter-mask');
                this.videoFilterItem = $all('.mfunsPlayer-videoFilter-item');
                this.videoColor = $('.mfunsPlayer-player-set.headbar-item.color');
                this.videoColorMask = $('.mfunsPlayer-player-videoColor-mask');
                this.videoClock = $('.mfunsPlayer-player-set.headbar-item.timeClose');
                this.videoClockMask = $('.mfunsPlayer-player-timeClose-mask');
                this.videoClockItem = $all('.mfunsPlayer-timeClose-item');
                this.feedback = $('.mfunsPlayer-player-set.headbar-item.feedback');
                this.feedbackMask = $('.mfunsPlayer-player-feedback-mask');
                this.feedbackDetail = $('.mfunsPlayer-feedback-detail');
                this.feedbackSubmit = $('.mfunsPlayer-feedback-submit');
                this.danmakuReportMask = $('.mfunsPlayer-player-danmaku-report-mask');
                this.danmakuReportDetail = $('.mfunsPlayer-danmaku-report-detail');
                this.danmakuReportSubmit = $('.mfunsPlayer-danmaku-report-submit');
                this.aspectRatio = $('.mfunsPlayer-player-set-row.aspect-ratio');
                this.playMode = $('.mfunsPlayer-player-set-row.play-mode');
                this.seekTip = $('.mfunsPlayer-time-tip');
                this.waitTip = $('.wait-tip');
                this.volumeTip = $('.mfunsPlayer-volume-tip');
                this.brightnessTip = $('.mfunsPlayer-brightness-tip');
                this.speedTip = $('.mfunsPlayer-speed-tip');
                this.fullscreenInput = $('.mfunsPlayer-fullscreen-input');
                this.fullscreenInputContent = $('.mfunsPlayer-fullscreen-input-content');
                this.fullscreenInputConfirmBTN = $('.mfunsPlayer-fullscreen-input-confirm-button');
                this.batteryStatus = $('.mfunsPlayer-headBar-battery');
                this.networkStatus = $('.mfunsPlayer-headBar-network');
                this.loginBtn = $('.login_btn');
            }
        },
        {
            key: 'newDanmakuEdit',
            value: function newDanmakuEdit() {
                var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                return tplDanmakuEdit(this.options.colors.concat(opt));
            }
        },
        {
            key: 'fillComponent',
            value: function fillComponent(name, targetNode) {
                targetNode.classList.add('mfunsPlayer-set');
                targetNode.appendChild(this[name]);
            }
        },
        {
            key: 'returnComponent',
            value: function returnComponent(name, sourceNode) {
                var component = sourceNode.firstChild;
                console.log(component);
                this[name] = component;
                this.setMask.appendChild(component);
            }
        }
    ], [
        {
            key: 'NewNotice',
            value: function NewNotice(text, opacity, id) {
                var notice = document.createElement('div');
                notice.classList.add('mfunsPlayer-notice');
                notice.style.opacity = opacity;
                notice.innerText = text;
                if (id) {
                    notice.id = 'mfunsPlayer-notice-'.concat(id);
                }
                return notice;
            }
        },
        {
            key: 'NewDanmakuListItem',
            value: function NewDanmakuListItem(dan) {
                var danData = JSON.parse(JSON.stringify(dan));
                danData.time = utils.secondToTime(danData.time, true);
                var danItemHTML = DanmakuListItem(danData);
                var danItem = new DOMParser().parseFromString(danItemHTML, 'text/html').body.firstChild;
                return danItem;
            }
        }
    ]);
    return Template;
}();
export default Template;